const authSchema = {
    aup3Vatek: 'aup3Vatek'
}

export default authSchema;
